import './chunk-1fafdf15.js';
import './helpers.js';
import './chunk-6985c8ce.js';
import { I as Icon } from './chunk-cdfca85b.js';
export { I as BIcon } from './chunk-cdfca85b.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Icon);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/esm/icon.js
// module id = 57
// module chunks = 10